import React from "react"
import PropTypes from "prop-types"
import * as yup from "yup"
import { useTranslation } from "react-i18next"
import { Formik, Form, Field } from "formik"
import { Spacer, Button } from "@bw/bits"
import { Input, FileInput, FormField } from "@bw/forms"
import YupPassword from "yup-password"
YupPassword(yup)

const ALLOWED_MIMETYPES = ["image/jpeg", "image/png"]

const Register = ({ onSubmit, setActiveStep }) => {
  const { t } = useTranslation()
  const initialValues = {
    name: "",
    email: "",
    password: "",
    password_repeat: "",
    avatar: null,
  }

  return (
    <Spacer>
      <Formik
        initialValues={initialValues}
        validationSchema={yup.object().shape({
          name: yup.string().required(),
          email: yup.string().required(),
          password: yup
            .string()
            .password()
            .minLowercase(1, "Utilisez au moins une lettre minuscule")
            .minUppercase(1, "Utilisez au moins une lettre majuscule")
            .minNumbers(1, "Utilisez au moins un nombre")
            .minSymbols(1, "Utilisez au moins un symbole (-_+*, etc.)")
            .min(12, "Utilisez au moins 12 caractères")
            .required(),
          password_repeat: yup
            .string()
            .oneOf([yup.ref("password"), null], t("form.passwordsMustMatch")),
          avatar: yup
            .mixed()
            .test("fileSize", t("validation.file_is_too_large"), value => {
              if (!value) return true
              return value.size <= 2_048_000
            })
            .test("fileType", t("validation.filetype_is_not_valid"), value => {
              if (!value) return true
              return ALLOWED_MIMETYPES.includes(value.type)
            }),
        })}
        onSubmit={(values, actions) => {
          actions.setSubmitting(true)

          const formData = new FormData()
          formData.append("name", values.name)
          formData.append("email", values.email)
          formData.append("password", values.password)
          formData.append("password_repeat", values.password_repeat)

          if (values.avatar) {
            formData.append("avatar", values.avatar)
          }

          onSubmit(formData).then(() => {
            console.log("salut")
          }).finally(() => {
            console.log("salut")
            actions.setSubmitting(false)
          })
        }}
      >
        {({ setFieldValue, isSubmitting }) => (
          <Form>
            <FormField title={t("authentication:name")} name="name" required>
              <Field type="text" id="name" name="name" component={Input} />
            </FormField>

            <FormField title={t("authentication:email")} name="email" required>
              <Field type="email" id="email" name="email" component={Input} />
            </FormField>

            <FormField
              title={t("authentication:password")}
              name="password"
              required
            >
              <Field
                type="password"
                id="password"
                name="password"
                component={Input}
              />
            </FormField>

            <FormField
              title={t("authentication:password_repeat")}
              name="password_repeat"
              required
            >
              <Field
                type="password"
                id="password_repeat"
                name="password_repeat"
                component={Input}
              />
            </FormField>

            <FormField title={t("authentication:avatar")} name="avatar">
              <Field
                name="avatar_file"
                component={FileInput}
                onChange={event => {
                  setFieldValue("avatar", event.currentTarget.files[0])
                }}
              />
            </FormField>

            <Button
              submit
              small
              label={t("authentication:registerSubmit")}
              disabled={isSubmitting}
            />
          </Form>
        )}
      </Formik>
      <div>
        <Button
          onClick={() => setActiveStep("login")}
          plain
          small
          label={t("authentication:iAlreadyHaveAnAccount")}
        />
      </div>
    </Spacer>
  )
}

Register.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired,
}

export default Register
